export default {
	URL: 'https://api-engel.infinitum-ti.com',
	API_URL: 'https://api-engel.infinitum-ti.com/api',
	OAPI_URL: 'https://api-engel.infinitum-ti.com/oapi',
	// API_URL: 'http://localhost:2386/api',
	// OAPI_URL: 'http://localhost:2386/oapi',
	// URL: 'http://localhost:2386',
}